import React from 'react';
import WalletCouponCard, {WalletCoupon} from '../atoms/WalletCouponCard';

type WalletCouponListProps = {
    coupons: Array<WalletCoupon>
}

export default function WalletCouponList(props: WalletCouponListProps) {
    const { coupons } = props;
    if (!coupons || coupons.length === 0)
        return <></>;
    return (
        <div style={{
            padding: '18px',
            borderRadius: '12px',
        }}>
            {coupons.map((c, i) => <WalletCouponCard key={i} coupon={c} />)}
        </div>
    );
}





